import styled from "styled-components";
import { hoverButton } from "../Layout";

export const SButton = styled.button<{ width?: string }>`
    height: 4rem;
    padding: 0 2.1rem;
    background: transparent;
    border: 1px solid ${props => props.theme.colors.white};
    cursor: pointer;
    border-radius: 10rem;
    color: ${props => props.theme.colors.white};
    font-weight: bold;
    font-size: 0.85rem;
    transition: all 0.5s ease;
    width: ${props => props.width ? props.width : undefined};
    &:hover{
     ${hoverButton}
     transform: translateY(-0.5rem);
}
`